exports.log = function (activityToken) {
    try {
        location.hostname.includes('localhost') && fetch('/scrumship.json').then(function (r) {
            return r.text();
        }).then(function (text) {
            var config = JSON.parse(text);
            fetch(config.url + '/' + config.pt + '/' + activityToken + '/' + config.u);
        });
    } catch (e) {
    }
}